export const BUILD_VERSION = '1790870268';
